module.exports = __webpack_public_path__ + "static/img/news-20231020.9d26f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20231020.png
// module id = jtws
// module chunks = 0